import React, { forwardRef } from 'react';
import RequiredFieldAsterisk from '../RequiredFieldAsterisk';

interface ISusyCheckboxProps
    extends React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
    > {
    dataTestId?: string;
    fieldIdentifier: string;
    label: string;
    formGroupProps?: {
        labelClasses?: string;
        labelDataTestId?: string;
        onLabelClick?: React.MouseEventHandler<HTMLLabelElement>;
    };
}

const SusyCheckbox = forwardRef(
    (props: ISusyCheckboxProps, ref: React.Ref<HTMLInputElement>) => {
        const {
            label,
            fieldIdentifier,
            dataTestId,
            className,
            formGroupProps,
            ...componentProps
        } = props;

        const classes = ['susy-checkbox'];
        if (className) {
            classes.push(className);
        }

        const labelClasses = [
            'susy-checkbox-label d-flex align-items-center cursor-pointer',
        ];
        if (formGroupProps?.labelClasses) {
            labelClasses.push(formGroupProps.labelClasses);
        }

        return (
            <>
                <input
                    name={`${fieldIdentifier}`}
                    id={`${fieldIdentifier}`}
                    {...componentProps}
                    type='checkbox'
                    ref={ref}
                    className={classes.join(' ')}
                    data-testid={dataTestId}
                />
                <label
                    htmlFor={`${fieldIdentifier}`}
                    className={labelClasses.join(' ')}
                    data-testid={formGroupProps?.labelDataTestId}
                    onClick={formGroupProps?.onLabelClick}
                >
                    {label} {props.required && <RequiredFieldAsterisk />}
                </label>
            </>
        );
    }
);

SusyCheckbox.displayName = 'SusyCheckbox';

export default SusyCheckbox;
